import React from 'react';
import './TestimonialsPage.css';

import { PageTitle } from '../../../components';
import { Testimonials } from '../../../sections';



const TestimonialsPage = () => {
  return (
    <div className='testimonials-page'>

      {/* Page title */}
      <PageTitle title={'testimonials'} page={'testimonials'} />

      {/* Testimonials section */}
      <Testimonials />

    </div>
  );
};

export default TestimonialsPage;